/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import SwitchField from "components/SwitchField";
import Footer from "./footer";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  fontSize: "14px",
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    id: 10000,
    stt: "C",
    code: "A",
    asset: "B",
    assetBold: true,
    assetCenter: true,
    sttBold: true,
    presentReadOnly: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    valueCenter: true,
    value: { present: "D", now: "1", before: "2" },
  },
  {
    id: 0,
    stt: "",
    code: "I",
    asset: "Hoạt động hành chính, sự nghiệp",
    assetBold: true,
    assetCenter: false,
    sttBold: true,
    presentReadOnly: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: "", before: "" },
  },
  {
    id: 1,
    stt: "01",
    code: "1",
    asset: "Doanh thu (01=02+03+04)",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 2,
    stt: "02",
    code: "",
    asset: "a. Từ NSNN cấp",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 3,
    stt: "03",
    code: "",
    asset: "b. Từ nguồn viện trợ, vay nợ nước ngoài",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 4,
    stt: "04",
    code: "",
    asset: "c. Từ nguồn phí được khấu trừ, để lại",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 5,
    stt: "05",
    code: "2",
    asset: "Chi phí (05=06+07+08)",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 6,
    stt: "06",
    code: "",
    asset: "a. Chi phí hoạt động",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 7,
    stt: "07",
    code: "",
    asset: "b. Chi phí từ nguồn viện trợ, vay nợ nước ngoài",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 8,
    stt: "08",
    code: "",
    asset: "c. Chi phí hoạt động thu phí",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 9,
    stt: "09",
    code: "3",
    asset: "Thặng dư/thâm hụt (09=01-05)",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 10,
    stt: "",
    code: "II",
    asset: "Hoạt động sản xuất kinh doanh, dịch vụ",
    assetBold: true,
    sttBold: true,
    presentReadOnly: false,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: "", before: "" },
  },
  {
    id: 11,
    stt: "10",
    code: "1",
    asset: "Doanh thu",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 12,
    stt: "11",
    code: "2",
    asset: "Chi phí",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 13,
    stt: "12",
    code: "3",
    asset: "Thặng dư/thâm hụt (12=10-11)",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 14,
    stt: "",
    code: "III",
    asset: "Hoạt động tài chính",
    assetBold: true,
    sttBold: true,
    presentReadOnly: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: "", before: "" },
  },
  {
    id: 15,
    stt: "20",
    code: "1",
    asset: "Doanh thu",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 16,
    stt: "21",
    code: "2",
    asset: "Chi phí",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 17,
    stt: "22",
    code: "3",
    asset: "Thặng dư/thâm hụt (22=20-21)",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 18,
    stt: "",
    code: "IV",
    asset: "Hoạt động khác",
    assetBold: true,
    sttBold: true,
    presentReadOnly: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: "", before: "" },
  },
  {
    id: 19,
    stt: "30",
    code: "1",
    asset: "Thu nhập khác",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 20,
    stt: "31",
    code: "2",
    asset: "Chi phí khác",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 21,
    stt: "32",
    code: "3",
    asset: "Thặng dư/thâm hụt (32=30-31)",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 22,
    stt: "40",
    code: "V",
    asset: "Chi phí thuế TNDN",
    assetBold: true,
    sttBold: true,
    presentReadOnly: false,
    presentBold: true,
    readOnly: false,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 23,
    stt: "50",
    code: "VI",
    asset: "Thặng dư thâm hụt trong năm (50=09+12+22+32-40)",
    assetBold: true,
    sttBold: true,
    presentReadOnly: false,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 24,
    stt: "51",
    code: "1",
    asset: "Sử dụng kinh phí tiết kiệm của đơn vị hành chính",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 25,
    stt: "52",
    code: "2",
    asset: "Phân phối cho các quỹ",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 26,
    stt: "53",
    code: "3",
    asset: "Kinh phí cải cách tiền lương",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
];

export default function Table2({ setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;

    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, value: { ...item.value, [name]: value } };
        }
        return item;
      })
    );
    console.log(data);
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Th style={{ textAlign: "center" }}>STT</Th>
              <Th style={{ textAlign: "center" }}>Chi tiêu</Th>
              <Th style={{ textAlign: "center" }}>Mã số</Th>
              <Th style={{ textAlign: "center" }}>Thuyết minh</Th>
              <Th style={{ textAlign: "center" }}>Năm nay</Th>
              <Th style={{ textAlign: "center" }}>Năm trước</Th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.length > 0 &&
              data.map((rows) => (
                <tr key={rows.id}>
                  <Td
                    style={{
                      textAlign: "center",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.assetBold === true ? "bold" : 400,
                    }}
                  >
                    {rows.code}
                  </Td>
                  <Td
                    style={{
                      textAlign: rows.assetCenter && rows.assetCenter === true ? "center" : "left",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.assetBold === true ? "bold" : 400,
                    }}
                  >
                    {rows.asset}
                  </Td>
                  <Td
                    style={{
                      textAlign: "center",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.sttBold === true ? "bold" : 400,
                    }}
                  >
                    {rows.stt}
                  </Td>
                  <Td
                    colSpan={1}
                    style={{
                      textAlign: "center",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.presentBold === true ? "bold" : 400,
                    }}
                  >
                    <InputTable2
                      id={rows.id}
                      name="present"
                      readOnly={rows.presentReadOnly}
                      value={rows.value.present}
                      onChange={handleChange}
                      fontWeight={rows.presentBold}
                    />
                  </Td>
                  {rows.valueCenter && rows.valueCenter === true ? (
                    <>
                      <Td
                        style={{
                          textAlign: "center",
                          background: rows.readOnly === true ? "#ddeff3" : "transparent",
                          fontWeight: rows.readOnly === true ? "bold" : 400,
                        }}
                      >
                        {rows.value.now}
                      </Td>
                      <Td
                        style={{
                          textAlign: "center",
                          background: rows.readOnly === true ? "#ddeff3" : "transparent",
                          fontWeight: rows.readOnly === true ? "bold" : 400,
                        }}
                      >
                        {rows.value.before}
                      </Td>
                    </>
                  ) : (
                    <>
                      <Td
                        colSpan={1}
                        style={{
                          textAlign: "right",
                          background: rows.readOnly === true ? "#ddeff3" : "transparent",
                          fontWeight: rows.readOnly === true ? "bold" : 400,
                        }}
                      >
                        <InputTable
                          id={rows.id}
                          name="now"
                          readOnly={rows.readOnly}
                          value={rows.value.now}
                          onChange={handleChange}
                          fontWeight={rows.valueBold}
                        />
                      </Td>
                      <Td
                        colSpan={1}
                        style={{
                          textAlign: "right",
                          background: rows.readOnly === true ? "#ddeff3" : "transparent",
                          fontWeight: rows.readOnly === true ? "bold" : 400,
                        }}
                      >
                        <InputTable
                          id={rows.id}
                          name="before"
                          readOnly={rows.readOnly}
                          value={rows.value.before}
                          onChange={handleChange}
                          fontWeight={rows.valueBold}
                        />
                      </Td>
                    </>
                  )}
                </tr>
              ))}
          </tbody>
        </table>
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, fontWeight, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ id, value: newValue !== "" ? +newValue : "", name });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: "14px",
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
        fontWeight: fontWeight && fontWeight === true ? "bold" : 400,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}

function InputTable2(props) {
  const { id, onChange, type, fontWeight, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  const regexDecimal = /^(0|0?\.\d*|1|1(\.0*)?)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value;
    if (type == "number") {
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name });
    } else if (type == "decimal") {
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name });
    } else {
      onChange({ id, value: newValue !== "" ? newValue : "", name });
    }
  }
  return (
    <input
      type={type == "date" ? "date" : ""}
      style={{
        textAlign: "center",
        fontSize: "14px",
        color: "#344767",
        border: "none",
        width: type == "date" ? "150px" : "100%",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        fontWeight: fontWeight === true ? "bold" : 400,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
